const faq = {
  talent: [
    {
      question: 'Muss ich bezahlen, um Zugang zu der Plattform zu erhalten?',
      answer:
        'Nein! Unsere Talente können unsere Services komplett kostenfrei nutzen!',
    },
    {
      question: 'Was ist das Hotlist Feature?',
      answer:
        'Auf der Top Talent Hotlist zu sein ermöglicht es Firmen, mit denen du matcht, sich mit dir in Verbindung zu setzen.',
    },
    {
      question:
        'Wie kontrolliere ich die Privatsphäre-Einstellungen meines Profils?',
      answer:
        'Ganz einfach! Du gehst auf deinem Profil auf "Verfügbarkeit" und stellst ein, welche Firmenprofile mit deinem interagieren dürfen.',
    },
    {
      question: 'Wie oft werden neue Stellen bei HYRE hinzugefügt?',
      answer:
        'Dafür gibt es keinen spezifischen Zeitraum, da dies von verschiedenen Variablen beeinflusst wird. Grundsätzlich gilt es regelmäßig auf der Plattform zu schauen, ob neue und relevante Stellen für dich hinzugefügt wurden.',
    },
    {
      question: 'Wie werde ich bei HYRE approved?',
      answer:
        'Nachdem du deinen CV und deine Sales Erfahrung im Profil hinterlegt hast, gleichen wir ab, ob dein Profil zu den Firmen auf der Plattform passt. Innerhalb von 1-2 Werktagen können wir bestimmen, ob wir aktuell die passenden Matches für dich haben.',
    },
    {
      question: 'Wann kann ich anfangen, mich zu bewerben?',
      answer:
        'Sobald du dein Profil angelegt hast, kannst du Bewerbungen abschicken! Du wirst die Nachricht erhalten, dass wir die Bewerbungen an die Firma weiterleiten werden, sobald du HYRE approved bist.',
    },
    {
      question:
        'Kann ich mich auf Jobs bei HYRE bewerben, ohne auf der Hotlist angezeigt zu werden?',
      answer:
        'Na klar! Allerdings ist unsere Empfehlung parallel zu den eigenen Bewerbungen auch Anfragen von Firmen zu generieren. Nutze die Gelegenheit ohne eigenen Aufwand mehr Matches zu bekommen!',
    },
    {
      question: 'Was passiert, nachdem ich mich für einen Job beworben habe?',
      answer:
        'Du bekommst von uns eine Email Benachrichtigung, sobald eine Firma bei der du dich beworben hast dich zu einem Interview einlädt. Dann kannst du dich ganz einfach über den jeweiligen Link für ein Interview eintragen. In manchen Fällen melden sich Firmen auch direkt bei dir per E-Mail oder Telefon. Viel Erfolg!',
    },
    {
      question:
        'Erhalte ich Unterstützung während der Benutzung der HYRE-Plattform?',
      answer:
        "Selbstverständlich! Du hast auf deinem Dashboard einen Button über den du jederzeit ein kostenloses Beratungsgespräch in Anspruch nehmen kannst. Nutze den Service gerne, falls du trotz der FAQ's noch offene Fragen hast. Unser Team ist für dich da!",
    },
  ],

  company: [
    {
      question: 'Wie funktioniert die Sortierung der Talente auf der Hotlist?',
      answer:
        'Die Talente werden zu deiner Position nach deinen individuell ausgewählten Kriterien automatisch gematched. Das bedeutet z. B. nach dem Ort, an dem du suchst und an dem das Talent bereit wäre zu arbeiten. Das Sprachniveau, die relevanten Tätigkeiten (Lead-Gen, Lead-Konverrtierung, etc.) Gerne kannst du mit den Filtern spielen und z. B. über Wohnort herausfinden, wo die Talente aktuell leben. Genauere Informationen findest du unter Minute 07:04.',
    },
    {
      question: 'Wann wird mein Kontingent von Hotlistanfragen erneuert?',
      answer:
        'Dein Kontingent wird in der Nacht von Mittwoch auf Donnerstag jede Woche automatisch erneuert.',
    },
    {
      question: 'Wann werden die neuen Talente der Woche veröffentlicht?',
      answer:
        'Wir veröffentlichen die neuen Talente jeden Donnerstag auf der Hotlist. Du bekommst dazu immer eine E-Mail von uns.',
    },
    {
      question: 'Ich habe ein Talent aus Versehen abgelehnt, was nun?',
      answer:
        'Bitte schreibe an customer.success@hyretalents.com, oder deinem Customer Success Manager eine E-Mail.',
    },
    {
      question: 'Kann ich meine Stellenanzeige anpassen?',
      answer:
        'Ja, indem du auf die Stellenanzeige gehst und oben rechts auf den Button »bearbeiten« klickst.',
    },
    {
      question: 'Kann ich die Stellenanzeige offline/online stellen?',
      answer:
        'Ja, dafür gehst du auf deine Stellenanzeigen und drückst auf den Regler, um die Position on- oder offline zunehmen.',
    },
    {
      question: 'Muss ich alle Angaben bei der Position ausfüllen?',
      answer:
        'Wir empfehlen alles möglichst genau auszufüllen, damit die Talente einen umfassenden Einblick zu der Position bekommen.',
    },
    {
      question: 'Kann ich die Gehaltsangaben auslassen?',
      answer:
        'Nein, wir bieten unseren Talenten volle Transparenz, daher ist die Gehaltsangabe ein Pflichtfeld.',
    },
    {
      question: 'Wie kann ich noch andere Städte eingeben?',
      answer:
        'Indem du die Stellenanzeige bearbeitest und aus dem Dropdown, die für dich relevanten Städte auswählst.',
    },
    {
      question: 'Wie lange dauert es, bis die erste Position live ist?',
      answer: 'Die Position geht in der Regel innerhalb 48h live.',
    },
    {
      question: 'Wie lange dauert es, bis die Position online/offline ist?',
      answer:
        'Die Position geht in Echtzeit live o. offline, wenn sie bereits einmal live geschaltet war.',
    },
    {
      question: 'Kann ich das Firmenprofil bearbeiten?',
      answer: 'Indem du auf den Reiter »Firmenprofil« gehst.',
    },
    {
      question: 'Wie lösche ich meinen Account?',
      answer:
        'Die unwiderrufliche Löschung des Accounts erfolgt unter »Einstellungen »Account löschen«',
    },
    {
      question: 'Wo finde ich die AGB?',
      answer: 'Unter »Einstellungen«',
    },
    {
      question: 'Wie kann ich das Abonnement beendet?',
      answer:
        'Solltest du dein Abonnement beenden möchten, kannst du dies über »Zahlungsdaten verwalten« tun, indem du dein aktives Paket anklickst und auf »beenden« klickst.',
    },
    {
      question: 'Wo kann ich meine Rechnungen einsehen?',
      answer:
        'Gehe in deine Einstellungen und auf »Zahlungsdaten verwalten«, dann gehst du auf Rechnungsverlauf.',
    },
    {
      question: 'Wo kann ich meine Zahlungsdaten ändern?',
      answer:
        'Gehe in deine Einstellungen und auf »Zahlungsdaten verwalten«, dann gehst du auf Zahlungsmethoden.',
    },
    {
      question: 'Ich habe einen Bug, wo kann ich den melden?',
      answer:
        'Du hast die Möglichkeit jederzeit über das Fragezeichen unten rechts uns deinen Bug/Fehler zu melden.',
    },
    {
      question: 'Ich habe Feedback, wo kann ich es hinterlassen?',
      answer:
        'Feedback kannst du gerne über das Fragezeichen unten rechts für uns hinterlassen.',
    },
  ],
}

export default {
  faq,
}
